(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cro-judgeme-theme"] && !Shopify.designMode) return;
  try {
    (function () {
  var LAZY_ATTRS = ['data-src', 'data-original', 'data-lazy', 'data-original-src'];
  var LAZY_SRCSET = ['data-srcset', 'data-original-srcset', 'data-lazy-srcset'];
  var ROOTS = '.jdgm-rev, .jdgm-rev-widg, .jdgm-prev-badge, .jdgm-carousel-item, .jdgm-rev__pic-wrap, .jdgm-rev__pictures, .jdgm-rev__media';

  function forceImage(img) {
    if (img.loading === 'lazy') img.loading = 'eager';
    if (img.decoding === 'async') img.decoding = 'auto';

    for (var i = 0; i < LAZY_ATTRS.length; i++) {
      var attr = LAZY_ATTRS[i];
      var v = img.getAttribute(attr);
      if (v && (!img.src || img.src.indexOf('data:') === 0 || img.src !== v)) {
        img.setAttribute('src', v);
        break;
      }
    }
    for (var j = 0; j < LAZY_SRCSET.length; j++) {
      var sattr = LAZY_SRCSET[j];
      var sv = img.getAttribute(sattr);
      if (sv && img.getAttribute('srcset') !== sv) {
        img.setAttribute('srcset', sv);
        break;
      }
    }
    img.style.opacity = '1';
    img.style.visibility = 'visible';
    img.style.display = 'block';
  }

  function forceSource(source) {
    for (var j = 0; j < LAZY_SRCSET.length; j++) {
      var sattr = LAZY_SRCSET[j];
      var sv = source.getAttribute(sattr);
      if (sv && source.getAttribute('srcset') !== sv) {
        source.setAttribute('srcset', sv);
        break;
      }
    }
  }

  function processJudgeme(label) {
    var roots = document.querySelectorAll(ROOTS);
    var imgCount = 0;
    var srcCount = 0;
    roots.forEach(function (root) {
      root.querySelectorAll('img').forEach(function (img) {
        imgCount++;
        forceImage(img);
        if (img.src && img.src.indexOf('data:') !== 0) srcCount++;
      });
      root.querySelectorAll('source').forEach(function (s) {
        forceSource(s);
      });
    });
    if (window.console && roots.length > 0) {
      console.log('[Belona/Judge.me] ' + (label || 'init') + ': ' + roots.length + ' widget root(s), ' + imgCount + ' images found, ' + srcCount + ' have valid src');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { processJudgeme('DOMContentLoaded'); });
  } else {
    processJudgeme('immediate');
  }
  window.addEventListener('load', function () { processJudgeme('load'); });

  var observer = new MutationObserver(function (mutations) {
    var shouldProcess = false;
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType === 1 && (
          (node.matches && node.matches(ROOTS)) ||
          (node.querySelector && node.querySelector(ROOTS))
        )) {
          shouldProcess = true;
        }
      });
    });
    if (shouldProcess) processJudgeme('mutation');
  });
  observer.observe(document.body, { childList: true, subtree: true });

  setTimeout(function () { processJudgeme('1s'); }, 1000);
  setTimeout(function () { processJudgeme('3s'); }, 3000);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cro-sticky-atc"] && !Shopify.designMode) return;
  try {
    (function () {
  const bar = document.querySelector('[data-cro-sticky-atc]');
  if (!bar) return;
  requestAnimationFrame(function () {
    bar.dataset.visible = 'true';
  });
})();
  } catch(e) { console.error(e); }
})();

})();
